import { render, staticRenderFns } from "./LoadIngArea.vue?vue&type=template&id=963ff8f2"
import script from "./LoadIngArea.vue?vue&type=script&lang=js"
export * from "./LoadIngArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports